import { LogLevel } from "@azure/msal-browser";

/**
 * MSAL (Microsoft Authentication Library) configuration for Azure AD authentication.
 * - Uses environment variables for sensitive values (clientId, tenantId, redirectUri).
 * - Sets cache location to sessionStorage for security (tokens cleared on browser close).
 * - Disables storing auth state in cookies by default.
 * - Provides detailed logging for MSAL events, excluding PII (Personally Identifiable Information).
 * - Suitable for React SPA with Azure AD SSO.
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID, // Azure AD Application (client) ID
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`, // Azure AD tenant
    redirectUri: process.env.REACT_APP_REDIRECT_URL, // Where Azure AD will redirect after login
  },
  cache: {
    cacheLocation: "sessionStorage", // sessionStorage recommended for SPAs
    storeAuthStateInCookie: false, // Set to true if issues on IE11/Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Login request configuration for MSAL.
 * - Scopes define the permissions the app is requesting from the user.
 * - "User.Read" allows reading user profile info.
 * - "profile" is a standard OpenID Connect scope.
 */
export const loginRequest = {
  scopes: ["User.Read", "profile"],
};
